// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes shimmer-loading--b7OgD{0%{background-position:200% 0}100%{background-position:-200% 0}}.page-error-boundary--JT0So{display:flex;flex-direction:column;width:100%;height:100vh;height:100dvh;color:#fff;justify-content:center;align-items:center;text-align:center;background-color:#5645f5;padding:1rem}.page-error-boundary--JT0So .reload-btn--JXR94{background-color:#fff}.page-error-boundary--JT0So i{font-size:96px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page-error-boundary": "page-error-boundary--JT0So",
	"reload-btn": "reload-btn--JXR94",
	"shimmer-loading": "shimmer-loading--b7OgD"
};
export default ___CSS_LOADER_EXPORT___;
